<template>
  <div class="col-100 recherche-avancee-grid recherche-avancee-substances-mode">
    <div class="mode-solubilite">
      <label
        for="mode-solubilite"
        class="label-bold"
      >
        Solubilité dans l'eau (mg/L)
      </label>
      <div class="double-input-row">
        <sign-choice-select
          :value="solubility_water_20Operator"
          :required="Boolean(solubility_water_20)"
          @update="$emit('update:solubility_water_20Operator', $event)"
        ></sign-choice-select>
        <input
          type="number"
          step="0.1"
          name="mode-solubilite"
          id="mode-solubilite"
          :value="solubility_water_20"
          @change="$emit('update:solubility_water_20', $event.target.value)"
        >
      </div>
    </div>

    <div class="mode-dja">
      <label
        for="mode-dja"
        class="label-bold"
      >
        DJA (mg/Kg/jour)</label>
      <div class="double-input-row">
        <sign-choice-select
          :value="djaOperator"
          :required="Boolean(dja)"
          @update="$emit('update:djaOperator', $event)"
        ></sign-choice-select>

        <input
          type="number"
          step="any"
          name="mode-dja"
          id="mode-dja"
          :value="dja"
          @change="$emit('update:dja', $event.target.value)"
        >
      </div>
    </div>

    <div class="mode-pnec">
      <label
        for="mode-pnec"
        class="label-bold"
      >
        PNEC (µg/L)
      </label>
      <div class="double-input-row">
        <sign-choice-select
          :value="pnecOperator"
          :required="Boolean(pnec)"
          @update="$emit('update:pnecOperator', $event)"
        ></sign-choice-select>

        <input
          type="number"
          step="0.1"
          id="mode-pnec"
          :value="pnec"
          @change="$emit('update:pnec', $event.target.value)"
        >
      </div>
    </div>

    <div class="mode-rac">
      <label
        for="mode-rac"
        class="label-bold"
      >
        Code RAC
      </label>
      <div class="double-input-row">
        <select
          name="mode-sigle"
          id="mode-sigle"
          :value="rac_type"
          @change="$emit('update:rac_type', $event.target.value)"
        >
          <option value=""></option>
          <option value="FRAC">FRAC</option>
          <option value="HRAC">HRAC</option>
          <option value="IRAC">IRAC</option>
        </select>
        <select
          name="mode-sigle"
          id="mode-sigle"
          :value="code_rac"
          @change="$emit('update:code_rac', $event.target.value)"
        >
          <option value=""></option>
          <option
            v-for ="type in getTypes(ractypesRef)"
            :key="type.name"
            :value="type[1]"
          >
          {{type[1]}}
          </option>
        </select>
      </div>
    </div>

    <div class="bloc-gris mode-insecticide">
      <label class="label-bold">Insecticide</label>
      <div class="bloc-gris_content">
        <label for="insecticide-plant-behavior">Comportement sur plante</label>
        <select
        id="insecticide-plant-behavior"
        :value="insecticide_plant_behavior"
        @change="$emit('update:insecticide_plant_behavior', $event.target.value)"
        >
          <option value=""></option>
          <option
            v-for="label in insecticidePlantBehaviorRef"
            :key="label"
          >
            {{ label }}
          </option>
        </select>
      </div>
      <div class="bloc-gris_content">
        <label>Mode de pénétration</label>
        <multiple-choice-checkboxes
          :nameRef="'insecticide_penetration'"
          :searchArray="insecticide_penetration"
          :refs="insecticidePenetrationModeRef"
          @update-search-array="$emit('update-search-array', $event)"
        ></multiple-choice-checkboxes>
      </div>
    </div>

    <div class="bloc-gris mode-fongicide">
      <label class="label-bold">Fongicide</label>
      <div class="bloc-gris_content">
        <label>Comportement sur plante</label>
        <multiple-choice-checkboxes
          :nameRef="'fungicide_plant_behavior'"
          :searchArray="fungicide_plant_behavior"
          :refs="fungicidePlantBehaviorRef"
          @update-search-array="$emit('update-search-array', $event)"
        ></multiple-choice-checkboxes>
      </div>
      <div class="bloc-gris_content">
        <label>Comportement sur champignons</label>
        <multiple-choice-checkboxes
          :nameRef="'fungicide_mushroom_behavior'"
          :searchArray="fungicide_mushroom_behavior"
          :refs="fungicideMushroomBehaviorRef"
          @update-search-array="$emit('update-search-array', $event)"
        ></multiple-choice-checkboxes>
      </div>
    </div>

    <div class="bloc-gris mode-herbicide">
      <label class="label-bold">Herbicide</label>
      <div class="bloc-gris_content">
        <label>Pénétration</label>
        <multiple-choice-checkboxes
          :nameRef="'herbicide_penetration'"
          :searchArray="herbicide_penetration"
          :refs="herbicidePenetrationModeRef"
          @update-search-array="$emit('update-search-array', $event)"
        ></multiple-choice-checkboxes>
      </div>
      <div class="bloc-gris_content">
        <label for="herbicide-migration-mode">Migration</label>
        <select
        id="herbicide-migration-mode"
        :value="herbicide_migration"
        @change="$emit('update:herbicide_migration', $event.target.value)"
        >
          <option value=""></option>
          <option
            v-for="label in herbicideMigrationModeRef"
            :key="label"
          >
            {{ label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import SignChoiceSelect from '@/components/SignChoiceSelect'
import MultipleChoiceCheckboxes from '@/components/MultipleChoiceCheckboxes'
export default {
  name: 'PropertyForm',

  components: { SignChoiceSelect, MultipleChoiceCheckboxes },

  props: {
    // binded search inputs
    solubility_water_20Operator: String,
    solubility_water_20: String,
    djaOperator: String,
    dja: String,
    pnecOperator: String,
    pnec: String,
    code_rac: String,
    rac_type: String,
    insecticide_plant_behavior: String,
    insecticide_penetration: Array,
    fungicide_plant_behavior: Array,
    fungicide_mushroom_behavior: Array,
    herbicide_penetration: Array,
    herbicide_migration: String,

    // data referentials
    ractypesRef: Array,
    insecticidePlantBehaviorRef: Array,
    herbicideMigrationModeRef: Array
  },

  data () {
    return {
      insecticidePenetrationModeRef: ['Contact', 'Ingestion', 'Vapeur'],
      fungicidePlantBehaviorRef: ['Curative', 'Eradiquante', 'Préventive'],
      fungicideMushroomBehaviorRef: ['Contact ', 'Pénétrant', 'Systémique', 'Cuticulaire'],
      herbicidePenetrationModeRef: ['Foliaire', 'Racinaire', 'Anti-germinatif']
    }
  }, 
  methods: {
    getTypes(array) {
      // console.log(array)
      if (this.rac_type === 'FRAC'){
        return array.filter( element => {
          return element[0] === 'FRAC'
      
      })
      }
      if (this.rac_type == 'HRAC'){
        return array.filter( element => {
        return element[0] === 'HRAC'
      })
      }
      if (this.rac_type === 'IRAC'){
        return array.filter( element => {
        return element[0] === 'IRAC'
      })
      }
      else {
        return ""
      }
     
    }
  }
}
</script>
